import {createRouter, createWebHashHistory} from 'vue-router'

const router = createRouter({
    history: createWebHashHistory(),  // hash 模式
    // history: createWebHistory(),  // history 模式
    // mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: "/homepage",
        },
        {
            path: '/homepage',
            name: 'homepage',
            component: () => import('../views/HomePage.vue'),
        },
        // {
        //     path: '/:faculty/profile',
        //     name: 'profile',
        //     component: () => import('../views/ScholarProfile.vue')
        // },
        {
            path: '/:faculty',
            name: 'index',
            component: () => import('../views/IndexPage.vue'),
            children: [
                {
                    path: 'intro',
                    component: () => import('../views/FacultyIntro.vue'),
                },
                {
                    path: 'people',
                    component: () => import('../views/FacultyPeople.vue'),
                },
                {
                    path: 'profile',
                    component: () => import('../views/ScholarProfile.vue')
                },
                {
                    path: 'results',
                    component: () => import('../views/ResultsStatistics.vue')
                },
                {
                    path: 'edit',
                    component: () => import('../components/EditProfile.vue')
                },
            ],
            meta: {
                title: '师资主页',
            },
        },
        {
            path: '/allpeople',
            name: 'allpeople',
            component: () => import('../views/AllPeople.vue'),
        }
    ]
})

export default router